import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin);

const $masthead = $('header.masthead');
const $navBackground = $('.masthead__nav-background');

// prepare elements for animation
gsap.set($('.masthead__nav .menu-item__dropdown .column'), { opacity: 0, y: -10 });
gsap.set($('.masthead__nav .menu-item__dropdown .card'), { opacity: 0, y: -10 });

$('.masthead__nav .menu-item__dropdown .column__title').each(function () {
    $(this).attr('data-original-text', $(this).text()).html('<span class="cursor"></span>');
});

// open sub-menus on hover
$('.masthead__nav .menu > .menu-item-has-children').on('mouseenter', function () {
    let $dropdown = $(this).find('.menu-item__dropdown'),
        $columns = $dropdown.find('.column'),
        $titles = $dropdown.find('.column__title'),
        $cards = $dropdown.find('.card');

    $dropdown.show();

    gsap.to($columns, {
        opacity: 1,
        y: 0,
        duration: .15,
        stagger: .1,
        ease: 'power1.out',
        delay: .2
    });

    gsap.to($titles, {
        text: (index, target) => {
            return target.getAttribute('data-original-text');
        },
        duration: .5,
        stagger: .5,
        ease: 'none',
        delay: .25
    });

    gsap.to($cards, {
        opacity: 1,
        y: 0,
        duration: .15,
        stagger: .1,
        ease: 'power1.out',
        delay: .2
    });

    gsap.to($navBackground, {
        opacity: 1,
        backdropFilter: 'blur(30px)',
        height: ($masthead.outerHeight() / 2) + $dropdown.outerHeight(),
        duration: .3,
        ease: 'power1.out'
    });
}).on('mouseleave', function () {
    $(this).find('.menu-item__dropdown').hide();

    // reset elements for animation
    gsap.set($('.masthead__nav .menu-item__dropdown .column'), { opacity: 0, y: -10 });
    gsap.set($('.masthead__nav .menu-item__dropdown .card'), { opacity: 0, y: -10 });
    $('.masthead__nav .menu-item__dropdown .column__title').html('<span class="cursor"></span>');

    gsap.to($navBackground, {
        opacity: 0,
        backdropFilter: 'blur(0)',
        height: '100%',
        duration: .3,
        ease: 'power1.out'
    });
});
